import React, {Component} from 'react';
import config from './config';
import nl2br from 'react-nl2br';
import AutoLinkText from 'react-autolink-text2';
import LazyLoad from 'react-lazyload';

const postQuery = {
  type: 'query',
  selects: [
    {
      type: 'select',
      expr: { type: "field", tableAlias: 'main', column: 'post'},
      alias: 'post'
    },
    {
      type: 'select',
      expr: { type: "field", tableAlias: 'main', column: 'id'},
      alias: 'id'
    },
    {
      type: 'select',
      expr: { type: "field", tableAlias: 'main', column: 'created_at'},
      alias: 'created_at'
    },
    {
      type: 'select',
      expr: { type: "field", tableAlias: 'main', column: 'attachment'},
      alias: 'attachment'
    },
    {
      type: 'select',
      expr: { type: "field", tableAlias: 'main', column: 'attachment_type'},
      alias: 'attachment_type'
    }
  ],
  from: { type: 'table', table: 'post', alias: 'main'},
  orderBy: [{ordinal: 2, direction: 'desc'}],
  limit: 100
}

const containerStyle = {
  position: 'relative',
  fontFamily: 'Helvetica',
  padding: 8,
  fontSize: 14
}

const itemStyle = {
  background: "#fff",
  marginBottom: 6,
  borderRadius: 2,
  boxShadow: `0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)`
}

const postTextStyle= {
  margin: 0
}

const time = {
  fontSize: 12,
  borderBottom: `1px solid #eaeaea`,
  padding: `8px`
}

const content = {
  padding: `8px`
}

const imageContainer = {
  marginTop: 10,
  background: '#f8f8f8'
}

const image = {
  maxWidth: '100%'
}

class LiveContainer extends Component {
  state = {
    feed: [],
    loading: false,
    lastUpdated: new Date()
  }

  componentDidMount() {
    this.setState({loading: true});
    fetch(`${config.api_base_url}/query?q=${JSON.stringify(postQuery)}`)
    .then(r => r.json())
    .then(posts=> {
      this.setState({loading: false, feed: posts.data})
    })

    const socket = io(config.ws_url);
    socket.on("post", post => {
      const posts = this.state.feed.slice()
      posts.unshift(post)
      this.setState({feed: posts})
    })

    socket.on("post_del", ({id}) => {
      const posts = this.state.feed.filter(p => p.id != id)
      this.setState({feed: posts})
    })

    this.timer = setInterval(() => {
      this.setState({lastUpdated: new Date()})
    }, 5000)
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  render() {
    const {height, width} = this.props;
    if(this.state.loading) {
      return (
        <div style={{width, height, textAlign: 'center', position: 'relative',fontFamily: 'Helvetica'}}>
          <p style={{fontSize: 12, position: 'absolute', width: 150, height: 10, left: width/2 - 75, top: height/2 - 5 }}>
            Loading live updates...
          </p>
        </div>
      )
    }

    const outerContainerStyle = {
      width, height, 
      overflow: 'auto', 
      background: "#efefef"
    }

    return (
      <div style={outerContainerStyle}>
        <div style={containerStyle}>
        {
          this.state.feed.map(p => (
            <div style={itemStyle} key={p.id}>
              <div style={time}>
                <span>{moment(p.created_at).fromNow()}</span>
              </div>
              <div style={content}>
                <p className="__viz_feedContent" style={postTextStyle}>
                <AutoLinkText text={p.post} linkProps={{target: "_blank"}}/>
                </p>
              </div>
              {
                !p.attachment || (
                  <div style={imageContainer}>
                    <img style={image} src={`${config.cdn_url}/posts/${p.attachment}`} alt={p.post} /> 
                  </div>
                )
              }
            </div>
          ))
        }
        </div>
      </div>
    )
  }
}

export default LiveContainer;


// WEBPACK FOOTER //
// ./src/LiveContainer.js